import Swiper from 'swiper/bundle'
import { gsap } from 'gsap'
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollToPlugin)

/**
 * PageHeroModule functionality.
 * @author Dayne Coulson-Hoffacker
 */

export default class PageHeroModule {
  /**
     * Constructs a new PageHeroModule instance.
     * @param {Object} options - Options.
     * @param {HTMLElement} options.element - Container.
     */

  constructor(options) {
    this.element = options.element
    this.swiperElement = this.element.querySelector('.swiper')
    this.swiperSlides = this.element.queryAll('.swiper-slide')
    this.scrollToBtn = this.element.querySelector('[data-component="scroll-btn"]')
    this.sections = document.body.querySelectorAll('section')

    if (this.scrollToBtn) {
      this.scrollToBtn.addEventListener('click', e => {
        e.preventDefault()
        if (!document.body.classList.contains('single-treatment')) {
          gsap.to(window, { duration: 1, scrollTo: { y: this.sections[1], offsetY: 78 }, ease: "power4" });
        } else {
          gsap.to(window, { duration: 1, scrollTo: { y: this.sections[1], offsetY: 149 }, ease: "power4" });
        }
      })
    }

    if (this.swiperSlides.length == 1) {
      const pageHeroSlider = new Swiper(this.swiperElement, {
        loop: false,
        slidesPerView: 1
      })
    } else {
      const pageHeroSlider = new Swiper(this.swiperElement, {
        loop: true,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 3500,
        },
      })
    }
  }
}
